import React from "react";
import {createUseStyles, useTheme} from "react-jss";
import {Theme} from "engage-client/theme";
import clsx from "clsx";
import {isUndefined} from "engage-common/utils";
import DisplayText, {TextVariant} from "engage-client/components/DisplayText";
import NotificationBubble from "../common/NotificationBubble";

//TODO:Need to figure out how to do multiple computed properties within one class
// @ts-ignore
const useTabStyles = createUseStyles<Theme>( (theme) => ({
    tab: {
        position:"relative",
        display:"flex",
        justifyContent:"center",
        alignItems: "center",
        flex: 1,
        textTransform: theme.accessoryPanel.tabs.largeTabSize ? "none" : "uppercase",
        fontSize:"0.875rem",
        letterSpacing:"0.03em",
        opacity: theme.accessoryPanel.tabs.largeTabSize ? 1 : 0.7,
        padding: [6,12],
        minHeight: theme.accessoryPanel.tabs.largeTabSize ? 45 : 36,
        cursor: "pointer",
        transition: "opacity 0.2s",
        [theme.breakpoints.down("md")]: {
            minHeight: 36
        },
        "&.selected": {
            opacity: 1,
        },
        "&:not(.last):after": {
            position: "absolute",
            content: "''",
            borderRight: "1px dashed white",
            right: -1,
            top: "25%",
            height: "50%"
        },
        "&:before": {
            top:0,
            position:"absolute",
            content:"''",
            borderTop: theme.accessoryPanel.tabs.largeTabSize ? theme.accessoryPanel.tabs.tabSelector : "1px solid #FFFFFFAA",
            width: "100%",
            transform: "scaleX(0)",
            transition: "transform .2s ease-in-out",
        },
        "&.selected:before": {
            transform: "scaleX(1)",
        }
    },
    tabContent: {
        position: "relative",
        display: "flex",
        alignItems: "center",
    },
    tabIcon: {
        width:12,
        height: 12,
        marginBottom: 2,
        marginRight: 5
    },
    tabLabel: {
        lineHeight: 1.4, //moves the border down a bit
        "&:after": {
            display: "block",
            content: "''",
            borderBottom: theme.accessoryPanel.tabs.largeTabSize ? "none" : theme.accessoryPanel.tabs.tabSelector,
            width: theme.accessoryPanel.tabs.largeTabSize ? 100 : 25,
            transform: "scaleX(0)",
            transition: "transform .2s ease-in-out",
            margin: theme.accessoryPanel.tabs.largeTabSize ? "auto" : "inherit"
        },
        "&.selected:after": {
            transform: "scaleX(1)",
        },
        color: theme.accessoryPanel.tabs.textColor ?? "white",
        fontWeight: theme.accessoryPanel.tabs.largeTabSize ? 700 : 400,
        textAlign: theme.accessoryPanel.tabs.largeTabSize ? "center" : "inherit",
    },
    tabNotification: {
        position: "absolute",
        top: -6,
        left: theme.accessoryPanel.tabs.largeTabSize ? 70 : -7,
        "&.large": {
            width:16,
            left: theme.accessoryPanel.tabs.largeTabSize ? 72 : -9
        }
    }
}));

export type AccessoryTabProps = {
    label:string
    icon?:string
    selected?:boolean
    value?:number
    onChange?:(newTab:number)=>void
    notificationCount?: number
    last?:boolean
}

export const AccessoryTab = ({label, icon, selected = false, value, onChange, notificationCount, last = false}:AccessoryTabProps) => {
    const classes = useTabStyles();

    const handleClick = () => {
        if(onChange && !isUndefined(value)) {
            onChange(value);
        }
    };
    let largeCount = (notificationCount ?? 0) > 99;
    const noteCount = largeCount ? "99+" : notificationCount;
    const theme:Theme = useTheme();
    return (
        <div className={clsx(classes.tab, selected && "selected", last && "last")}
             onClick={handleClick} data-qa="tab" data-value={label}>
            <div className={classes.tabContent}>
                {notificationCount ? <NotificationBubble className={clsx(classes.tabNotification,largeCount && "large")}>{noteCount}</NotificationBubble> : null}
                {icon && <img src={icon} alt={`Tab icon for ${label}`} className={classes.tabIcon}/>}
                <DisplayText className={clsx(classes.tabLabel, selected && "selected")} variant={theme.accessoryPanel.tabs.largeTabSize ? TextVariant.s16reg : TextVariant.s12reg}>{label}</DisplayText>
            </div>
        </div>
    );
};